'use strict';

export default function f($filter) {
  'ngInject';

  return {
    it(input) {
      return $filter('lowercase')($filter('spacesWithDashes')(input));
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/slug.js